import { Component, Input, OnInit } from '@angular/core';
import { IssueModel, IssueTrackModel } from 'src/app/shared/models/issue.model';
import { IssueTrackService } from 'src/app/shared/services/issue-track.service';

@Component({
  selector: 'app-issue-track-list',
  templateUrl: './issue-track-list.component.html',
  styleUrls: ['./issue-track-list.component.css']
})
export class IssueTrackListComponent implements OnInit {
  @Input() issue : IssueModel;
  thisData : IssueTrackModel [];
  constructor(private service : IssueTrackService) { }

  ngOnInit() {

    this.refreshList();
  }

  refreshList()
  {
    if(this.issue == null) return;

    this.service.findDataByIssue(this.issue.issueId).subscribe(
      res => {
        this.thisData = res as IssueTrackModel [];
       },
       err =>{
         console.log(err);
       }
    );
   
  }
}
